// Gallery items — derived from real Reformity project photos (/data/photos.js).

import { PROJECT_PHOTOS } from "@/data/photos";

export const GALLERY_CATEGORIES = [
    { id: "all", label: "All" },
    { id: "fencing", label: "Fencing" },
    { id: "interlocking", label: "Interlocking" },
    { id: "decking", label: "Decking" },
    { id: "concrete", label: "Concrete" },
    { id: "landscaping", label: "Landscaping" },
    { id: "renovations", label: "Renovations" },
];

// Default city when a photo doesn't have one tagged
const DEFAULT_CITY = "GTA";

// Flatten the per-service photo manifest into a single gallery list. Each item
// carries id, src (webp), fallback (jpg), alt, category (display label),
// service (slug), title, city, w, h.
const flatten = () => {
    const items = [];
    for (const [slug, photos] of Object.entries(PROJECT_PHOTOS)) {
        for (const p of photos) {
            items.push({
                ...p,
                title: p.category, // friendly display name from source folder
                city: DEFAULT_CITY,
                image: p.src, // alias used by ServiceDetail.FeaturedProjects
                category: slug, // overwrites the source folder name with our slug
            });
        }
    }
    return items;
};

export const GALLERY_ITEMS = flatten();
